import { render } from "./AnnouncementModal.vue?vue&type=template&id=06365865&scoped=true"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js"

import "./AnnouncementModal.vue?vue&type=style&index=0&id=06365865&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Master-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06365865"]])

export default __exports__